import { z } from 'zod';

// Les `message` sont des clés de traduction (namespace `auth.errors`).
export const forgotPasswordSchema = z.object({
  email: z.string().email({ message: 'emailInvalid' }),
});
export type ForgotPasswordInput = z.infer<typeof forgotPasswordSchema>;

export const updatePasswordSchema = z
  .object({
    password: z.string().min(8, { message: 'passwordTooShort' }),
    confirmPassword: z.string().min(1, { message: 'confirmPasswordRequired' }),
  })
  .refine((d) => d.password === d.confirmPassword, {
    message: 'passwordsMismatch',
    path: ['confirmPassword'],
  });

export type UpdatePasswordInput = z.infer<typeof updatePasswordSchema>;
